import { h, Component } from 'preact';
import styles from './text_field_style';
import classNames from 'classnames';


export default class TextField extends Component {
  updateValue = (e) => {
    console.log(this.props);
    this.props.updateValue(e.target.value);
  }
  render({field, isValid, response},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
      <input id={field.mapping} name={field.mapping} defaultValue={response.value} type="text" size="20" placeholder={field.label} class={classes} onBlur={this.updateValue} />
		);
	}
}
